<template>
  <QPaginatedSearchDropdown :key="resetKey" :value="value" :list-getter="getFilteredSupplierFailureCodes"
    :filter="filter" :min-search-char-limit="0" :allow-create="allowCreate" :externaledit="externaledit"
    :clearable="clearable" :multiple="multiple" :returnobject="returnobject" :disabled="disabled"
    :disableAttach="disableAttach" :loading="createLoading || loading" valuekey="Id" textkey="Description"
    :label="label ? label : $t('servicesystem.common_objects.supplier_failure_code.supplier_failure_code')"
    :placeholder="placeholder ? placeholder : $t('servicesystem.common_objects.supplier_failure_code.search_field_label')"
    :rules="rules" @input="e => $emit('input', e)" @create="e => createNew(e)"
    @FocusState="e => $emit('FocusState', e)">

    <template v-if="!hideIcon" v-slot:prepend-outer>
      <v-icon size="20">$supplier_failure_code</v-icon>
    </template>

    <template v-if="!multiple" v-slot:selection="{ item }">
      <div class="nowrapheader" style="max-width: 100%;">
        <span style="color: var(--v-primary-base);">{{ item.Code }}</span>&nbsp;-&nbsp;{{ item.Description }}
      </div>
    </template>

    <template v-slot:item-content="{ item, highlight }">
      <div class="nowrapheader" style="max-width: 100%;">
        <span style="color: var(--v-primary-base);" v-html="highlight(item.Code)"></span>
        &nbsp;-&nbsp;
        <span style="color: var(--v-text-base);" v-html="highlight(item.Description)"></span>
      </div>
    </template>

  </QPaginatedSearchDropdown>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import QPaginatedSearchDropdown from "@/components/Inputs/QPaginatedSearchDropdown.vue";
import rules from "@/helpers/Mixins/QInputRuleMixin.js";

export default {
  name: "SupplierFailureCodeSelect2",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    placeholder: String,
    value: [Object, String, Number, Array],
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    filter: Object,
    returnobject: Boolean,
    multiple: Boolean,
    rules: Array,
    allowCreate: Boolean,
    hideIcon: Boolean,
    disableAttach: Boolean,
  },
  components: {
    QPaginatedSearchDropdown,
  },
  mixins: [clientAPI, rules],

  data() {
    return {
      createLoading: false,
      resetKey: 1,
    };
  },

  methods: {
    async createNew({ value, onComplete }) {
      this.createLoading = true;
      var supplierId = this.filter?.SupplierIdList?.[0] ?? 1; //cant be null or 0 due to db constraints, this will at least allow the code to be created. You should be using this in a context where you have a supplier filter applied.
      const dto = { Code: value, Description: this.$t("servicesystem.common_objects.commonterms.code") + " " + value, SupplierId: supplierId };
      clientAPI.methods.createSupplierFailureCode(dto)
        .then(async response => {
          var val = this.returnobject ? response : response.Id;
          if(this.multiple){
            val = [...this.value, val];
          }
          this.$emit('input', val);
          this.$emit('change', val);
          await onComplete();
          //reset required to force reload while in editmode
          if (this.externaledit) {
            this.resetKey++;
          }
        })
        .finally(() => {
          this.createLoading = false;
        });
    },
  },

  computed: {},

  watch: {},
};
</script>


<style lang="scss"></style>